import { Component, input, computed } from "@angular/core";
import { RouterLink } from "@angular/router";
import { EvGridTableModule, ITableLayoutModel, ITableHeader, BaseListComponent } from "ev-grid-table";
import { NearbySaleDto } from "src/models/sales/nearby-sales.model";
import { CommonModule } from "@angular/common";
import { EVEstateType } from "src/models/units/unit-attributes.model";
import { EvTooltipModule } from "ev-tooltip";
import { ThousandizePipe, UnitPipe } from "ev-core";
import { DefaultConverterPipe } from "src/app/shared/pipes/defaultconverter.pipe";

@Component({
    selector: "nearby-sales",
    templateUrl: "./nearby-sales.component.html",
    styleUrl: "./nearby-sales.component.scss",
    imports: [EvGridTableModule, CommonModule, EvTooltipModule, ThousandizePipe, DefaultConverterPipe, UnitPipe, RouterLink],
})
export class NearbySalesComponent extends BaseListComponent<NearbySaleDto> {
    nearbySales = input.required<NearbySaleDto[]>();

    originalData = computed(() => this.nearbySales() || []);

    EVEstateType = EVEstateType;
    residentialMeasuredAreaTooltipVisible = false;

    constructor() {
        super();
    }

    toggleResidentialMeasuredAreaTooltip(event: any): void {
        event.preventDefault();
        event.stopPropagation();
        this.residentialMeasuredAreaTooltipVisible = !this.residentialMeasuredAreaTooltipVisible;
    }

    onHeaderTooltipClick(event: any): void {
        event.preventDefault();
        event.stopPropagation();
    }

    protected createHeaders(): ITableHeader[] {
        return [
            {
                name: "Dato",
                prop: "sortDate",
                desc: true,
                type: "date",
                isSortable: true,
            },
            {
                name: "Adresse",
                prop: "concatenatedAddress",
                desc: true,
                type: "text",
                isSortable: true,
            },
            {
                name: "Eieform",
                prop: "ownershipType",
                desc: true,
                type: "text",
                isSortable: true,
            },
            {
                name: "m²",
                prop: "residentialMeasuredArea",
                desc: true,
                type: "number",
                isSortable: true,
            },
            {
                name: "Etg",
                prop: "floor",
                desc: true,
                type: "number",
                isSortable: true,
            },
            {
                name: "Soverom",
                prop: "numberOfBedrooms",
                type: "number",
                desc: true,
                isSortable: true,
            },
            {
                name: "Byggeår",
                prop: "buildYear",
                type: "number",
                desc: true,
                isSortable: true,
            },
            {
                name: "Pris",
                prop: "price",
                type: "number",
                desc: true,
                isSortable: true,
            },
            {
                name: "Megler",
                prop: "estateAgent",
                type: "text",
                desc: true,
                isSortable: true,
            },
        ];
    }

    protected createDisplayTemplate(): ITableLayoutModel {
        return {
            breakPoints: [
                {
                    gridAreas:
                        '"estate-type-icon ownershipType price" "sortDate sortDate sortDate" "buildYear buildYear buildYear" "residentialMeasuredArea residentialMeasuredArea residentialMeasuredArea" "floor floor floor" "numberOfBedrooms numberOfBedrooms numberOfBedrooms" "concatenatedAddress concatenatedAddress concatenatedAddress" "estateAgent estateAgent estateAgent"',
                    gridColumns: "40px 130px 120px",
                    maxWidth: 445,
                },
                {
                    gridAreas:
                        '"estate-type-icon sortDate ownershipType price" "buildYear buildYear buildYear buildYear" "residentialMeasuredArea residentialMeasuredArea residentialMeasuredArea residentialMeasuredArea" "floor floor floor floor" "numberOfBedrooms numberOfBedrooms numberOfBedrooms numberOfBedrooms" "concatenatedAddress concatenatedAddress concatenatedAddress concatenatedAddress" "estateAgent estateAgent estateAgent estateAgent"',
                    gridColumns: "40px 100px 130px 120px",
                    maxWidth: 760,
                },
                {
                    gridAreas:
                        '"estate-type-icon sortDate ownershipType residentialMeasuredArea floor numberOfBedrooms buildYear price" "concatenatedAddress concatenatedAddress concatenatedAddress concatenatedAddress concatenatedAddress concatenatedAddress concatenatedAddress concatenatedAddress" "estateAgent estateAgent estateAgent estateAgent estateAgent estateAgent estateAgent estateAgent"',
                    gridColumns: "40px 100px 130px 100px 60px 80px 60px 120px",
                    maxWidth: 1030,
                },
                {
                    gridAreas:
                        '"estate-type-icon sortDate concatenatedAddress ownershipType residentialMeasuredArea floor numberOfBedrooms buildYear price" "estateAgent estateAgent estateAgent estateAgent estateAgent estateAgent estateAgent estateAgent estateAgent"',
                    gridColumns: "40px 100px 1fr 130px 100px 60px 80px 60px 120px",
                    maxWidth: 1300,
                },
                {
                    gridAreas:
                        '"estate-type-icon sortDate concatenatedAddress ownershipType residentialMeasuredArea floor numberOfBedrooms buildYear price estateAgent"',
                    gridColumns: "40px 100px 1fr 130px 100px 60px 80px 60px 120px 1fr",
                },
            ],
        };
    }
}
